import { apiClient } from "./ApiClient";

/**
 * Get all ACTIVE saved filter sets for a component
 * GET /api/user/filters/{componentName}
 */
export const retrieveUserSavedFiltersApi = (componentName) =>
  apiClient.get(`/api/user/filters/${componentName}`);


/**
 * Create a new saved filter set
 * POST /api/user/filters
 */
export const saveUserSavedFilterApi = (componentName, filterName, filterPayloadJson) =>
  apiClient.post(`/api/user/filters`, {
    componentName,
    filterName,
    filterPayload: filterPayloadJson,
  });


/**
 * Update an existing saved filter set
 * PUT /api/user/filters/{id}
 */
export const updateUserSavedFilterApi = (id, filterName, filterPayloadJson) =>
  apiClient.put(`/api/user/filters/${id}`, {
    filterName,
    filterPayload: filterPayloadJson,
  });


/**
 * Soft delete (sets recordStatus = PASSIVE)
 * DELETE /api/user/filters/{id}
 */
export const deleteUserSavedFilterApi = (id) =>
  apiClient.delete(`/api/user/filters/${id}`);
